import React, { Fragment, useEffect, useState, useContext } from "react";
import "./quiz.css";
import { Button, MIcon, Text, Line, Flex, PopClose } from "./Uikit";
import { Link, withRouter, useHistory } from "react-router-dom";
import { MetaContext } from "../context";
import { uniqueId } from "lodash";
import { Product } from "./Product";
import { getDataById, getDataById2 } from "./Utilities";
import { CSSgrid } from "./Catalog";
import uniqid from "uniqid";
import { CSSstackGrid } from './StackExpanded';
import { Appearer } from './Appearer';
import styled, { css, StyleSheetManager } from "styled-components";

function QuizInner({ history, match, location }) {
  const context = useContext(MetaContext);
  const [shown1, setShown1] = useState();
  const [shown2, setShown2] = useState();

  const [quiz, setQuiz] = useState();

  const [questionActive, setQuestionActive] = useState(0);

  const [qStack, setQstack] = useState([]);


  const navigate = useHistory();

  useEffect(() => {
    if (!shown1) {
      setTimeout(() => {
        setShown1(true);
      }, 10);
    }
    if (!shown2) {
      setTimeout(() => {
        setShown2(true);
      }, 300);
    }
    if (history && match && location) {
      setQuiz(match.params.quizId);
    }
    return () => {
      // if (typeof shown1 !== 'undefined') {
      //   setShown1(false)
      //   setShown2(false)
      //   // debugger
      //   // navigate('/');
      // }
    };
  }, [match]);

  useEffect(() => {
    if (typeof shown1 !== "undefined" && shown1 === false) {
      setTimeout(() => {
        history.push("/");
      }, 500);
    }
  }, [shown1, shown2]);

  const getQuizTitle = (id) => {
    let q = context.handles.getQuizes().filter(one => one['code'] === id)[0]
    return q ? q['title'] : ''
  }

  return (
    <div className="q0 active" style={{ zIndex: 10000000 }}>
      <div className={`qb ${shown1 ? "active" : ""}`}>
        <div className={`qb_bg ${shown1 ? "active" : ""}`} />

        <div className={`qb_inner ${shown2 ? "active" : ""}`}>

          <div className="q_top">
          <PopClose
            handle={() => {
              setShown1(false);
              setShown2(false);
            }}
          />

            <div className="q_path0">
              {!quiz && <div className={`q_node q_node--current`}>Quizes</div>}
              {Boolean(quiz) && <><Link to='/quiz'
              onClick={()=> setQuestionActive(0)}
              className={`q_node ${!quiz ? 'q_node--current' : '' }`}>Quizes</Link><div className="q_node"><MIcon size={11}>chevron_right</MIcon></div></>}
              {Boolean(quiz) && <div className="q_node q_node--current">{getQuizTitle(quiz)}</div>}
            </div>


          </div>

          {context && !quiz && (
            <>
              <div className='q_c'>

                <div className={`q_c_inner active`}>

                  <div className="q_q">
                    <div className="q_1">
                      <Text>What does concern you?</Text>
                    </div>
                  </div>

                  <div className="q_a0">
                  {context.handles.getQuizes().map((one, i) => {
                    return (
                      <Link className='q_a' to={`/quiz/${one["code"]}`} key={`quiz_${i}`}>
                        {one["title"]}
                      </Link>
                    );
                  })}
                  </div>

                </div>

              </div>
            </>
          )}

          {context && quiz && Boolean(context.handles.getQuiz(quiz).length) && (
            <>
              <QuizTrack
                total={context.handles.getQuiz(quiz).length}
                active={questionActive}
                handle={(i) => setQuestionActive(i)}
              />

              {/* {[context.handles.getQuiz(quiz)[questionActive]].map((oneQuestion, i) => {
              return <QuizQuestion
                key={uniqueId()}
                handleNext = {()=> setQuestionActive(questionActive + 1)}
                {...oneQuestion}
              />;
            })} */}

              {Boolean(context.handles.getQuiz(quiz)[questionActive]) && (

                  <QuizQuestion
                    key={uniqueId()}
                    handleNext={(products) => {
                      setQuestionActive(questionActive + 1);
                      setQstack([...qStack, ...products]);
                    }}
                    {...context.handles.getQuiz(quiz)[questionActive]}
                  />

              )}

              {!Boolean(context.handles.getQuiz(quiz)[questionActive]) &&
                Boolean(qStack.length) && (
                  <div className='q_c'>
                    <div className='q_c_inner active'>
                      <QuizStack quiz={quiz} qStack={qStack} history={history} />
                    </div>
                  </div>
                )}

              {!Boolean(context.handles.getQuiz(quiz)[questionActive]) &&
                !Boolean(qStack.length) && (
                  <div className='q_c'>
                    <div className='q_c_inner active'>
                      <QuizStackNoProducts history={history} />
                    </div>
                  </div>
                )}
            </>
          )}

          <div className="q_f" />
        </div>
      </div>
      <div className={`qz ${shown1 ? "active" : ""}`} />
    </div>
  );
}

const QuizTrack = ({ total, active, handle }) => {
  let a = [];
  for (var i = 0; i < total; i++) {
    a.push("");
  }

  return (
    <div className="q_p0">
      {a.map((oneA, i) => {
        if (i < active) {
          return (
            <Flex vertical center key={`q_${i}`}>
              <div className="q_p done">
                <div className="q_p_click" onClick={() => handle(i)}>
                  {i + 1}
                </div>
              </div>
              {i < total - 1 && <div className="q_p_l done" />}
            </Flex>
          );
        }
        if (i === active && i < total - 1) {
          return (
            <Flex vertical center key={`q_${i}`}>
              <div className="q_p active" />
              {i < total && <div className="q_p_l" />}
            </Flex>
          );
        }
        if (i !== active && i < total - 1) {
          return (
            <Flex vertical center key={`q_${i}`}>
              <div className="q_p" key={`q_${i}`}>
                <div className="q_p_click" onClick={() => handle(i)}>
                  {i + 1}
                </div>
              </div>
              {i < total && <div className="q_p_l" />}
            </Flex>
          );
        }
        if (i === total - 1) {
          return (
            <Flex vertical center key={`q_${i}`}>
              <div className={`q_p ${active === i ? "active" : ""}`}>
                <div className="q_p_click" onClick={() => handle(i)}>
                  {i + 1}
                </div>
              </div>
            </Flex>
          );
        }
        if (active === total) {
          return <></>;
        }
      })}
    </div>
  );
};

const QuizQuestion = ({
  handleNext,
  q_en,
  q_ru,
  a1_en,
  a2_en,
  a3_en,
  a4_en,
  a1_ru,
  a2_ru,
  a3_ru,
  a4_ru,
  a1_sups = [],
  a2_sups = [],
  a3_sups = [],
  a4_sups = [],
}) => {

  const [active, setActive] = useState(0)
  useEffect(() => {
    setActive(1)
  }, [])

  let answers = [];
  const context = useContext(MetaContext);
  if (context.state.locale === "en") {
    answers = [
      {
        answer: a1_en,
        products: a1_sups,
      },
      {
        answer: a2_en,
        products: a2_sups,
      },
      {
        answer: a3_en,
        products: a3_sups,
      },
      {
        answer: a4_en,
        products: a4_sups,
      },
    ];
  }
  if (context.state.locale === "ru") {
    answers = [
      {
        answer: a1_ru,
        products: a1_sups,
      },
      {
        answer: a2_ru,
        products: a2_sups,
      },
      {
        answer: a3_ru,
        products: a3_sups,
      },
      {
        answer: a4_ru,
        products: a4_sups,
      },
    ];
  }

  answers = answers.filter((a) => a["answer"]);

  return (
    <>
      <div className="q_c">
        <div className={`q_c_inner ${active === 1 ? 'active' : ''} ${active === 2 ? 'after' : ''}`}>

          <div className="q_q">
            <div className="q_1">
              <Text>{q_en}</Text>
            </div>
            {/* <h3><Text>What's your stool frequency?</Text></h3> */}
          </div>
          <div className="q_a0">
            {answers.map((oneA) => (
              <div
                className="q_a"
                key={`answer_${oneA["answer"]}_${uniqid()}`}
                onClick={() => {
                  setActive(2)
                  setTimeout(() => {
                    setActive(0)
                  }, 180);
                  setTimeout(() => {
                    handleNext(oneA["products"])
                  }, 400);
                }}
              >
                {oneA["answer"]}
              </div>
            ))}
          </div>

        </div>

      </div>
    </>
  );
};

const QuizStackNoProducts = ({ history }) => {
  return (
    <>
      <Line xlg>
        <Flex center>
          <h3>
            <Text center>
              Basing on your answers,<br/>we don't recommend any supplements
            </Text>
          </h3>
        </Flex>
      </Line>
      <Line>
        <Flex center>
          <Button
            ghost
            onClick={() => {
              history.push("/");
            }}
          >
            Great! Close this quiz
          </Button>
        </Flex>
      </Line>
    </>
  );
};

const QuizStack = ({ quiz = "gut_health", qStack = [], history }) => {
  const context = useContext(MetaContext);

  qStack = [...new Set(qStack)];
  qStack = qStack.filter((oneQid) => getDataById2(context, oneQid));

  const [stack2add, setStack2add] = useState([...qStack]);

  const handleAddRemove = (id) => {
    if (stack2add.includes(id)) {
      setStack2add([...stack2add.filter((el) => el !== id)]);
    } else {
      setStack2add([...stack2add, id]);
    }
  };

  return (
    <>
      <Line xlg>
        <Text center>
          <h3>
            <Text center>
              Basing on your answers,<br/>we recommend adding these supplements to
              your stack
            </Text>
          </h3>
        </Text>
      </Line>

      <Line xlg style={{position: 'relative', zIndex: 4}}>
        <Flex center>
          <CSSquizGrid>
            {qStack.map((oneQid, i) => {
              let data = getDataById2(context, oneQid);
              if (data) {
                return (
                  <Appearer key={`product_stack_${data["name"]}}`} order={i}>
                    <Product
                      appearance="quiz"
                      sm
                      active={stack2add.includes(oneQid)}
                      handle={handleAddRemove}
                      data={data}
                      key={uniqid()}
                    />
                  </Appearer>
                );
              } else {
                return null;
              }
            })}
          </CSSquizGrid>
      </Flex>
      </Line>

      <Line>
        <Flex center>
          {Boolean(stack2add.length) && <Button
            disabled={!context.handles.getStack()}
            onClick={() => {
              // qStack.forEach(oneId => context.handles.handleStack(oneId))
              // context.handles.addToStack(
              //   qStack.map((id) => {
              //     let item = getDataById2(context, id);
              //     return {
              //       id: item["id"],
              //       useWhen: item["when"],
              //     };
              //   })
              // );
              context.handles.createStack({
                id: "",
                title: context.handles.getQuiz(quiz, "all")["title"],
                stack: [
                  ...stack2add.map((id) => {
                    let item = getDataById2(context, id);
                    return {
                      id: item["id"],
                      useWhen: item["when"],
                    };
                  }),
                ],
              });

              history.push("/stack");
            }}
          >
            {stack2add.length === qStack.length && <>Add all to stack</>}
            {stack2add.length !== qStack.length && <>{`Add ${stack2add.length} item${stack2add.length > 1 ? 's' : ''} to stack`}</>}
          </Button>}
          &nbsp;&nbsp;
          <Button
            ghost
            onClick={() => {
              history.push("/");
            }}
          >
            Later
          </Button>
        </Flex>
      </Line>
    </>
  );
};

export const Quiz = withRouter(QuizInner);



const CSSquizGrid = styled.div`
  display: grid;
  grid-row-gap: 1em;
`